// extracted by mini-css-extract-plugin
export var banner = "Layout-module--banner--0d465";
export var bannerIcon = "Layout-module--banner-icon--cd2db";
export var bannerText = "Layout-module--banner-text--e1c84";
export var cdsAssistiveText = "Layout-module--cds--assistive-text--f485d";
export var cdsHideFeedback = "Layout-module--cds--hide-feedback--28d4e";
export var cdsShowFeedback = "Layout-module--cds--show-feedback--61b99";
export var cdsSkeleton = "Layout-module--cds--skeleton--dfc4d";
export var cdsVisuallyHidden = "Layout-module--cds--visually-hidden--053d7";
export var layout = "Layout-module--layout--2a4ac";
export var layoutNoBanner = "Layout-module--layout-no-banner--4a2f0";